import { useInfiniteQuery } from '@tanstack/react-query';
import { getTimeline } from '../services/timelineService';
import type { TimelineRange } from '../types/timeline';

/**
 * @param filterTypes comma-separated API event types (e.g. "journal_entry,image"), as before.
 * @param range optional zoom window (#1442). Omitted → unchanged query key and request.
 */
export function useTimeline(aquariumId: string, filterTypes?: string, range?: TimelineRange) {
  return useInfiniteQuery({
    queryKey: range !== undefined ? ['timeline', aquariumId, filterTypes, range] : ['timeline', aquariumId, filterTypes],
    queryFn: ({ pageParam }) =>
      getTimeline(aquariumId, {
        limit: 30,
        before: pageParam as string | undefined,
        types: filterTypes,
        ...(range !== undefined ? { range } : {}),
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.data.hasMore ? (lastPage.data.nextCursor ?? undefined) : undefined,
  });
}
